import { PageHeader } from '@/components/layout/PageHeader'
import { mockKpiData, mockBuildings, allMockUnits } from './data/mockSpaceRevenue'
import { Button } from '@/components/ui/button'
import { Download } from 'lucide-react'
import { KPISection } from './components/KPISection'
import { BuildingVisualBreakdown } from './components/BuildingVisualBreakdown'
import { UnitDetailTable } from './components/UnitDetailTable'

// Placeholder components - will be extracted later
// KpiSection moved to components/reports/KPISection.tsx

// BuildingVisualSection moved to components/reports/BuildingVisualBreakdown.tsx

// UnitDetailTable moved to components/reports/UnitDetailTable.tsx

export const SpaceRevenueReportPage = () => {
  return (
    <div className="flex flex-col h-full bg-background">
      <PageHeader 
        title="Space Revenue & Utilization" 
        description="Phoenix Sky Harbor FBO · As of Feb 18, 2026"
      >
        <div className="flex items-center gap-2">
            <Button variant="outline" size="sm">
                <Download className="w-4 h-4 mr-2" /> Export
            </Button>
        </div>
      </PageHeader>
      
      <div className="flex-1 overflow-auto p-6 md:p-8 pt-6">
        <div className="max-w-7xl mx-auto">
            {/* Section 1: KPI Cards */}
            <KPISection data={mockKpiData} />

            {/* Section 2: Building Visuals */}
            <BuildingVisualBreakdown buildings={mockBuildings} />

            {/* Section 3: Unit Table */}
            <UnitDetailTable units={allMockUnits} />
        </div>
      </div>
    </div>
  )
}

export default SpaceRevenueReportPage
